import React from 'react';
import { Avatar, useChatContext } from 'stream-chat-react';
import { useHistory } from 'react-router-dom';

import './TeamChannelPreview.css';

import { TeamTypingIndicator } from '../TeamTypingIndicator/TeamTypingIndicator.jsx';

export const TeamChannelPreview = (props) => {
  const {
    channel,
    setActiveChannel,
    setIsCreating,
    setIsEditing,
    type,
    unread,
  } = props;
  const history = useHistory();

  const { channel: activeChannel, client } = useChatContext();

  const ChannelPreview = () => (
    <div className='flex w-full justify-between'>
      <div className='channel-preview__item single'>
        <Avatar
          image={channel?.data?.image || undefined}
          name={channel?.data?.name || channel?.data?.id || 'name'}
          size={24}
        />
        <p>{channel?.data?.name || 'N/A'}</p>
      </div>
      <div>
        {unread !== 0 ? (
          <p className='text-center w-6 h-6 bg-brand-primary rounded-full text-white mr-4'>
            {' '}
            {unread}{' '}
          </p>
        ) : null}
        <TeamTypingIndicator type='list' />
      </div>
    </div>
  );

  const DirectPreview = () => {
    const members = Object.values(channel.state.members).filter(
      ({ user }) => user.id !== client.userID
    );
    const defaultName = 'Johnny Blaze';

    if (!members.length || members.length === 1) {
      return (
        <div className='flex w-full justify-between'>
          <div className='channel-preview__item single'>
            <Avatar
              image={members[0]?.user.image || undefined}
              name={members[0]?.user.name || members[0]?.user.id}
              size={24}
            />
            <p>{members[0]?.user.name || members[0]?.user.id || defaultName}</p>
          </div>
          {unread !== 0 ? (
            <p className='text-center w-6 h-6 bg-brand-primary rounded-full text-white mr-4'>
              {' '}
              {unread}{' '}
            </p>
          ) : null}
          <TeamTypingIndicator type='list' />
        </div>
      );
    }

    return (
      <div className='channel-preview__item multi'>
        <span>
          <Avatar
            image={members[0]?.user.image || undefined}
            name={members[0]?.user.name || members[0]?.user.id}
            size={18}
          />
        </span>
        <Avatar
          image={members[1]?.user.image || undefined}
          name={members[1]?.user.name || members[1]?.user.id}
          size={18}
        />
        <p>
          {members[0]?.user.name || members[0]?.user.id || defaultName},{' '}
          {members[1]?.user.name || members[1]?.user.id || defaultName}
        </p>
      </div>
    );
  };

  return (
    <div
      className={
        channel?.id === activeChannel?.id
          ? 'channel-preview__wrapper__selected'
          : 'channel-preview__wrapper'
      }
      onClick={() => {
        setIsCreating(false);
        setIsEditing(false);
        setActiveChannel(channel);
        history.push(`/job-dashboardv2/chat/${channel.id}`);
      }}
    >
      {type === 'team' ? <ChannelPreview /> : <DirectPreview />}
    </div>
  );
};
